var _style, _path, _path2, _path3, _path4, _path5, _defs, _clipPath, _path6, _defs2, _clipPath2, _path7, _defs3, _clipPath3, _path8, _defs4, _clipPath4, _path9, _defs5, _clipPath5, _path10, _defs6, _clipPath6, _path11, _g, _g2, _g3, _path12, _g4, _path13, _path14, _path15, _path16, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunPointLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 172.9 36.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0095da}.st1{fill:#fff}.st16{fill:#ed1c24}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4 1.4v30.8H15v-9.8h8.7v-7.7H15V9.1h11.7V1.4H1.4zm86.1 10c0 .5-.1 1-.3 1.4-.2.4-.4.8-.7 1.1-.3.3-.7.5-1.1.7s-.9.3-1.4.3c-.3 0-.7-.1-1.1-.2V8.1h1.5c1 0 1.7.3 2.3.9.6.6.8 1.4.8 2.4m12.8.4c0-2-.5-3.9-1.6-5.5-.5-.8-1.2-1.5-1.9-2.1-.8-.7-1.6-1.2-2.5-1.6s-1.9-.7-2.9-.9-2.1-.3-3.2-.3H69.4v30.8H83V19.5c1.3 1 2.5 1.6 3.6 2.1 1.1.4 2.2.6 3.5.6 1.8 0 3.5-.5 5.1-1.4S98 18.6 99 17c.8-1.5 1.3-3.3 1.3-5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5 10.6v10.8c0 .4-.1.7-.2.9-.1.2-.2.4-.4.5s-.4.2-.6.2c-.4 0-.7-.2-.9-.5s-.2-.9-.2-1.8V10.6h-9.5v9.6c0 3 .4 5.4 1.3 7 .9 1.7 2.2 3 3.9 3.9 1.7.9 3.6 1.4 5.5 1.4 2 0 3.9-.5 5.6-1.5.9-.5 1.6-1.1 2.3-1.8.6-.7 1.2-1.4 1.6-2.3.4-.9.7-1.8.9-2.9s.3-2.2.3-3.5v-10l-9.6.1zm10.5 0v21.6h9.6v-6.6l4.6 6.7h7.2V10.6h-9.5v7.2h-.1l-5-7.2H47zm72.5 0h9.5v21.6h-9.5V10.6zm10.5 0v21.6h9.5v-6.6h.1l4.6 6.7h7.2V10.6h-9.5v7.2h-.1l-5-7.2H130zm22.4 0v9.6h4.8v12h9.5v-12h4.8v-9.6h-19.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.5 34.5c7.2 1.9 14.6-2.4 16.6-9.6 1.9-7.2-2.4-14.6-9.6-16.6-7.2-1.9-14.6 2.4-16.6 9.6-1.9 7.2 2.4 14.7 9.6 16.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.3 7.9c-.4-.5-.9-.8-1.4-1-1.2-.3-2.4.3-3.4 1.4 1.5-.4 3.2-.5 4.8-.4m8.3 3.9c-.3-1.5-1.1-2.6-2.2-2.9-.6-.2-1.2-.1-1.7.2 1.4.7 2.7 1.6 3.9 2.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.7 33.6c6.7 1.8 13.7-2.2 15.5-8.9S116 11 109.3 9.2s-13.7 2.2-15.5 8.9c-1.8 6.8 2.2 13.7 8.9 15.5",
    fill: "#ffdb00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1 17.4c1.9.5 4.1-1.4 4.9-4.3s-.2-5.7-2.1-6.2-4.1 1.4-4.9 4.3.1 5.7 2.1 6.2",
    clipPath: "url(#SVGID_2_)",
    fill: "#fff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1 17.4c1.4.4 3-.9 3.5-2.8s-.2-3.8-1.7-4.2c-1.4-.4-3 .9-3.6 2.8-.4 1.9.3 3.8 1.8 4.2",
    clipPath: "url(#SVGID_4_)",
    fill: "#8ed8f8"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 19.4c1.9.5 4.1-1.4 4.9-4.3s-.2-5.7-2.1-6.2-4.1 1.4-4.9 4.3c-.7 2.9.2 5.7 2.1 6.2",
    clipPath: "url(#SVGID_6_)",
    fill: "#fff"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 19.4c1.4.4 3-.9 3.5-2.8s-.2-3.8-1.7-4.2c-1.4-.4-3 .9-3.6 2.8-.4 1.9.4 3.8 1.8 4.2",
    clipPath: "url(#SVGID_8_)",
    fill: "#8ed8f8"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.3 16.5c1 .3 2.1-.7 2.4-2.1.4-1.4-.1-2.8-1-3.1-1-.3-2.1.7-2.4 2.1-.4 1.5 0 2.9 1 3.1",
    clipPath: "url(#SVGID_10_)",
    fill: "#006daf"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M102.3 13.4c-.4 1.4.1 2.8 1 3.1 1 .3 2.1-.7 2.4-2.1.4-1.4-.1-2.8-1-3.1h-.3c-.9 0-1.8.9-2.1 2.1"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.6 20.8c1.4.4 3-.9 3.5-2.8s-.2-3.8-1.7-4.2c-1.4-.4-3 .9-3.6 2.8-.4 1.9.4 3.8 1.8 4.2",
    clipPath: "url(#SVGID_12_)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.8 18.5c1 .3 2.1-.7 2.4-2.1.4-1.4-.1-2.8-1-3.1-1-.3-2.1.7-2.4 2.1-.5 1.5 0 2.9 1 3.1",
    clipPath: "url(#SVGID_14_)",
    fill: "#006daf"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M109.7 15.4c-.4 1.4.1 2.8 1 3.1 1 .3 2.1-.7 2.4-2.1.4-1.4-.1-2.8-1-3.1h-.3c-.8 0-1.7.9-2.1 2.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.1 22.8c1.4.4 3-.9 3.5-2.8s-.2-3.8-1.7-4.2c-1.4-.4-3 .9-3.6 2.8-.4 1.9.3 3.8 1.8 4.2",
    clipPath: "url(#SVGID_16_)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M93.8 18.1c-1.8 6.7 2.2 13.7 8.9 15.5 6.7 1.8 13.7-2.2 15.5-8.9C120 18 116 11 109.3 9.2c-1.1-.3-2.2-.4-3.3-.4-5.6 0-10.7 3.7-12.2 9.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 13.8c.3.1.6-.3.8-.7.1-.5 0-.9-.3-1s-.6.3-.8.7c-.1.4 0 .9.3 1m7.4 2c.3.1.6-.3.8-.7.1-.5 0-.9-.3-1s-.6.3-.8.7c-.1.4.1.9.3 1",
    clipPath: "url(#SVGID_18_)",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1 19.8c-.8 4.6 2 9.1 6.5 10.3 4.6 1.2 9.3-1.3 10.8-5.7-2.8 1.6-6.3 2.2-9.7 1.3-3.3-.8-6-3.1-7.6-5.9",
    fill: "#006daf"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M103.7 30.1c4.6 1.2 9.3-1.3 10.8-5.7-2.8 1.6-6.3 2.2-9.7 1.3-3.4-.9-6.1-3.1-7.7-6-.8 4.7 2 9.2 6.6 10.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.7 33.6c1.9.5 3.9-.6 4.4-2.6.5-1.9-.6-3.9-2.6-4.4s-3.9.6-4.4 2.6c-.4 1.9.7 3.9 2.6 4.4",
    clipPath: "url(#SVGID_20_)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M103.7 30.1c4.6 1.2 9.3-1.3 10.8-5.7-2.8 1.6-6.3 2.2-9.7 1.3-3.4-.9-6.1-3.1-7.7-6-.8 4.7 2 9.2 6.6 10.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.4 27.5c7.7 2.1 15.6-2.5 17.7-10.2 2.1-7.7-2.5-15.6-10.2-17.7S96.3 2.1 94.2 9.8s2.5 15.6 10.2 17.7",
    clipPath: "url(#SVGID_22_)",
    fill: "#fff"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1 19.8c-.8 4.6 2 9.1 6.5 10.3 4.6 1.2 9.3-1.3 10.8-5.7-2.8 1.6-6.3 2.2-9.7 1.3-3.3-.8-6-3.1-7.6-5.9z",
    fill: "none",
    stroke: "#ed1c24",
    strokeWidth: 0.637
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.1 24.9c2.4.6 4.8-.4 5.3-2.3s-1-4-3.4-4.7c-2.4-.6-4.8.4-5.3 2.3-.6 2 1 4.1 3.4 4.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3 14.8c.1 0 .3-.1.3-.3.1-.2 0-.4-.1-.4s-.3.1-.3.3c-.1.2 0 .4.1.4m8.3 2.3c.1 0 .3-.1.3-.3.1-.2 0-.4-.1-.4s-.3.1-.3.3c-.1.2 0 .3.1.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117 25.3c-.3-1.5-1.1-2.6-2.2-2.9-.6-.2-1.2-.1-1.7.2 1.5.6 2.8 1.6 3.9 2.7m-17.7-6.5c-.4-.5-.9-.8-1.4-1-1.2-.3-2.4.3-3.4 1.4 1.6-.4 3.2-.5 4.8-.4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.9 5c0-2.1 1.4-3.5 3.4-3.5 1.9 0 3.2 1.3 3.2 3.2 0 1.3-.6 2.3-1.6 2.3-.8 0-1.3-.5-1.7-1.6h-.4v1.5h-.5V3.2c.3-.1.6-.1.9-.1.8 0 1.4.5 1.4 1.1 0 .5-.4 1-.9 1.1.3.7.7 1.2 1.2 1.2.7 0 1-.7 1-1.7 0-1.7-1-2.8-2.6-2.8s-2.8 1.3-2.8 3c0 1.9 1.3 3.2 3.2 3.2.5 0 1.1-.1 1.6-.3v.5c-.5.2-1.1.3-1.6.3-2.2 0-3.8-1.6-3.8-3.7zm2.9-1.5V5h.4c.5 0 .9-.3.9-.7 0-.5-.3-.8-.9-.8h-.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunPointLogo);
export default __webpack_public_path__ + "static/media/fun_point_logo.0860c11c37b6d8291be221655078335d.svg";
export { ForwardRef as ReactComponent };